import { LoadStatusEnum } from './load-state.enum';

export class LoadState<T> {

  constructor(init?: Partial<LoadState<T>>) {
    if (init)  {
      Object.assign(this, init);
    }
  }
  date: Date;
  data: T;
  error: string ;
  status: LoadStatusEnum;
}
